import { useEffect, useRef, useState } from 'react';

import {
  CurrentFile,
  FileArea,
  FileCSVContainer,
  Placeholder,
  UploadBar,
  Wrapper,
} from './styles';

const FileCSV = (props) => {
  const [isDragActive, setIsDragActive] = useState(false);
  const [currentFile, setCurrentFile] = useState();
  const [uploadStats, setUploadStats] = useState({
    loaded: 0,
    total: 0,
    progress: 0,
  });
  const [currentContent, setCurrentContent] = useState();
  const [hasFile, setHasFile] = useState(false);
  const [contentHeaders, setContentHeaders] = useState([]);
  const [fileTypeError, setFileTypeError] = useState();

  const inputRef = useRef(null);

  useEffect(() => {
    if (!currentContent) setCurrentContent(props.value);
  }, [props.value]);

  useEffect(() => {
    if (props.errorMessage && props.errorMessage.length > 0) {
      clearCurrentFile();
    }
  }, [props.errorMessage]);

  const clearCurrentFile = () => {
    setHasFile(false);
    setCurrentFile(undefined);
    setCurrentContent(undefined);
    setContentHeaders([]);
    setUploadStats({ loaded: 0, total: 0, progress: 0 });
    setFileTypeError(undefined);
  };

  const ACCEPTED_TYPES = [
    'text/csv',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
  ];

  const handleFile = (file) => {
    const isAccepted =
      ACCEPTED_TYPES.includes(file.type) ||
      /\.(csv|xlsx)$/i.test(file.name);
    if (isAccepted) {
      props.onChange && props.onChange(file);
      readCSV(file);
      setFileTypeError(undefined);
    } else {
      setFileTypeError('O tipo de arquivo é inválido. Use .csv ou .xlsx');
    }
  };

  const readCSV = (file) => {
    const reader = new FileReader();
    setCurrentFile(file);
    reader.readAsBinaryString(file);
    reader.onprogress = (e) => {
      setUploadStats({
        loaded: e.loaded,
        total: e.total,
        progress: Math.round((e.loaded / e.total) * 100),
      });
    };
    reader.onloadend = () => {
      const result = reader.result;
      setCurrentContent(result);
      setHasFile(true);
      getContentHeaders(result);
    };
  };

  const getFileSizeInfo = (loaded, total) => {
    return total < 1000
      ? `${loaded} de ${total} bytes`
      : total < 1000000
      ? `${Math.round(loaded / 1000)} de ${Math.round(total / 1000)} KB`
      : `${Math.round(loaded / 1000000)} de ${Math.round(total / 1000000)} MB`;
  };

  const getContentHeaders = (content) => {
    const headers = content
      .trim()
      .replaceAll('\r', '')
      .replaceAll(';', ',')
      .split('\n')[0]
      .split(',');
    setContentHeaders(headers);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
  };

  const handleDrop = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsDragActive(false);
    clearCurrentFile();

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const handleChange = (e) => {
    clearCurrentFile();
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files[0]);
    }
  };

  return (
    <FileCSVContainer>
      <Wrapper hasFile={hasFile}>
        <CurrentFile hasFile={hasFile}>
          <UploadBar progress={uploadStats.progress}>
            <h4>
              <strong>{currentFile?.name}</strong>
            </h4>
            <div className="uploadProgress">
              <div className="uploadProgressFiller" />
            </div>
            <div className="fileSizeInfo">
              <label>
                {getFileSizeInfo(uploadStats.loaded, uploadStats.total)}
              </label>
              <label>{uploadStats.progress}% Completo</label>
            </div>
          </UploadBar>
        </CurrentFile>

        <FileArea
          hasFile={hasFile}
          onDragEnter={handleDragEnter}
          onDragOver={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <Placeholder>{props.children}</Placeholder>
          <input
            name={props.name}
            type="file"
            ref={inputRef}
            value={props.value}
            onChange={handleChange}
            accept=".csv,.xlsx"
          />
        </FileArea>
      </Wrapper>
    </FileCSVContainer>
  );
};

export default FileCSV;
